import React from "react";
import {List, Avatar, Button, Skeleton, Popover, Input, Col, Row, Select, Card, Radio, PageHeader} from 'antd';
import moment from "moment";
import reqwest from 'reqwest';
import Connector from "../../../redux/connector";
import Title from "../../../components/Common/Title";
import Page from "../../../layout/web/Page";
import PlusOutlined from "@ant-design/icons/es/icons/PlusOutlined";

import {AudioOutlined} from '@ant-design/icons';
import HeaderNewCase from "../../../components/Common/workboard/HeaderNewCase";
import NewCaseDrawer from "../../../components/Common/workboard/NewCaseDrawer";
import {Form} from "antd";
import {GetUserToken} from "../../../api/token";
import {fetchDataEntity} from "../../../api/entity-data";
import {
    csvJSON,
    findRecordDisplayKey, findRecordKey, findRecordKey2, findRecordKeyField, findRecordKeyField2,
    findRecordType, findRecordUniqueKey, GetListField,
    GetRecordDisplayName,
    LoadDataAnyEndpoint,
    LoadDataNoCondition,
    SortData,
    SortDataDesc, SubmitLogInformation,
    UpcaseFirst
} from "../../../api/fn";

import {SearchOutlined} from '@ant-design/icons';

import NewUserDrawer from "../Settings/Users/NewUserDrawer";
import DrawerNewEntry from "../../../components/General/DrawerNewEntry";
import NewActivityDrawer from "../../../components/Common/workboard/NewActivityDrawer";
import NewStatusDrawer from "../../../components/Common/workboard/NewStatusDrawer";
import NewPriorityDrawer from "../../../components/Common/workboard/NewPriorityDrawer";
import MoreDetailDrawer from "../../../components/Common/workboard/MoreDetailDrawer";
import NewStageDrawer from "../../../components/Common/workboard/NewStageDrawer";
import NewCommentDrawer from "../../../components/Common/workboard/NewCommentDrawer";
import {act} from "@testing-library/react";
import NewReminderDrawer from "../../../components/Common/workboard/NewReminderDrawer";
import GenericComboBox from "../../../components/General/GenericComboBox";
import {PostToPbx} from "../../../api/http-post";


const {Option} = Select;
const {Search} = Input;
const suffix = (
    <AudioOutlined
        style={{
            fontSize: 16,
            color: '#1890ff',
        }}
    />
);
const count = 3;
const fakeDataUrl = `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat&noinfo`;

class WorkboardViewIncidentPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Companies: [],
            Projects: [],
            Attributes: [],
            Databases: [],
            DatabasesView:[],
            Files: [],
            Fields: [],
            selectedCompany: "",
            selectedProject: "",
            initLoading: false,
            loading: false,
            data: [],
            list: [],
            showActions: {},
            searchText: "",
            showNewCase: false,
            newEntry: {},
            Users: [],
            UserVoips: [],
            UserProjects: [],
            Comments: [],

            totalEscalated: 0,
            totalNewCase: 0,
            totalOutbound: 0,
            totalInbound: 0,
            totalStatus: "Online",

            ActionData: null,
            showActionActivity: false,
            showActionStage: false,
            showActionActionStatus: false,
            showActionPriority: false,
            showMoreDetail: false,
            showActionComment: false,
            showActionReminder:false,
            moreDetailData: null,

            Activities: [],
            Statuses: [],
            Stages: [],
            Priorities: [],
            Informations: [],
            filters: {},
            filtersAdditions: {},
            typeFilter: "options",
            selectedOptions:"",
        };

        this.arrayholder = [];
    }

    componentDidMount = async () => {

        await this.initialReload();
        await this.loadDatabase();
        /*await this.getData((data) => {
            console.log("get data loaded 100% > ", data)
        })*/
    }
    initialReload = async () => {
        //await fetchDataEntity("Companies", "client/entity", "company", this);
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        await fetchDataEntity("Attributes", "", "", this, undefined, "common/entity/attributes/list");
        await fetchDataEntity("Fields", "", "", this, undefined, "common/entity/Fields/list");
        await fetchDataEntity("Files", "", "", this, undefined, "common/entity/files/list");
        await fetchDataEntity("UserVoips", "", "", this, undefined, "common/entity/AllocationUserViop/list");
        await fetchDataEntity("UserProjects", "", "", this, undefined, "common/entity/AllocationUserProject/list");
        await fetchDataEntity("Databases", "", "", this, undefined, "common/entity/databases/list");
        await fetchDataEntity("Activities", "", "", this, undefined, "common/entity/Activities/list");
        await fetchDataEntity("Stages", "", "", this, undefined, "common/entity/Stages/list");
        await fetchDataEntity("Statuses", "", "", this, undefined, "common/entity/Statuses/list");
        await fetchDataEntity("Priorities", "", "", this, undefined, "common/entity/Priorities/list");
        await fetchDataEntity("Informations", "", "", this, undefined, "common/entity/Informations/list");
        await fetchDataEntity("Comments", "", "", this, undefined, "common/entity/Comments/list");
        await fetchDataEntity("DatabasesView", "", "", this, undefined, "common/entity/DatabasesView/list");

        await this.loadUsers();
        await this.initializeData();
    }
    loadUsers = async () => {
        let userInfo = GetUserToken();
        let hub = {};
        // hub.Org = userInfo.Org;
        let endpoint = "/user/list";
        await LoadDataAnyEndpoint(hub, endpoint, "Users", this, (data) => {
            console.log("loadUsers > ", data)
        });

    }
    initializeData = async () => {
        let userInfo = GetUserToken();
        let paramsProject = {};
        let paramsCompany = {};
        if (userInfo.Role !== "super") {
            paramsProject = [
                {key: "Org", val: userInfo.Org, type: "string"},
            ];
            paramsCompany = [
                {key: "CustomerNumber", val: userInfo.Org, type: "string"},
            ];
        }
        await this.fetchData("companies", "Companies", paramsCompany, null);
    }
    fetchData = async (table, stateKey, params, feedback) => {
        let _this = this;
        let userInfo = GetUserToken();
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = params;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })
        await PostToPbx(post, endpoint, async (data) => {
            let res = [];
            if (data !== null) {
                res = data.RESULT;
            }
            await _this.setState({
                [stateKey]: res
            });
            console.log("fetchData response === > ", table, " > ", post, data);
            if (feedback !== null) {
                feedback(res)
            }
        });
    }
    handleChangeCompany = async (val, key) => {
        this.setState({
            [key]: val,
        });
    }
    findUserName = (username) => {
        for (let i in this.state.Users) {
            let row = this.state.Users[i];
            if (row.Username === username) {
                return row.FullName;
            }
        }
        return username;
    }
    requestMoreDetailView = (item) => {
        this.setState({
            showMoreDetail: true,
            moreDetailData: item,
        })
    }
    getLastAction = (org, project, ref) => {
        let arrData = this.state.Informations;
        arrData = SortData("orgdatetime", arrData);
        let status = '', priority = '', stage = '', statusColor = '', priorityColor = '', activity = '';
        for (let i in arrData) {
            let row = arrData[i];
            if (row.org !== org) {
                continue
            }
            if (row.project !== project) {
                continue
            }
            if (row.ref !== ref) {
                continue
            }

            if (row.action === "status") {
                status = row.name;
                statusColor = row.data.color;
            }

            if (row.action === "priority") {
                priority = row.name;
                priorityColor = row.data.color;
            }

            if (row.action === "stage") {
                stage = row.name;
            }
            if (row.action === "activity") {
                activity = row.name;
            }

        }

        return {status, statusColor, priority, priorityColor, stage, activity}

    }
    loadDatabase = async () => {

        let _this = this;
        let userInfo = GetUserToken();
        let info = this.getInfo();
        let {project} = info;
        let org = userInfo.Org;

        console.log("> F3 ", org, " > ", info);

        let ls = [];
        let defautlUrl = "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
        let databases = SortDataDesc("orgdatetime",this.state.Databases);
        for (let i in databases) {
            let row = databases[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            let name = GetRecordDisplayName(org, project, row, this.state.Attributes, "displayselection");
            let ref = row.ref;
            //let status=this.findStatus(row),stage=this.findStage(row),priority=this.findPriority(row);
            let {stage, priorityColor, priority, statusColor, status, activity} = this.getLastAction(org, project, ref);
            let description = (<div> Status: <span style={{color: statusColor}}> {status}</span>
                ; Priority: <span style={{color: priorityColor}}>{priority}</span> ; Stage: {stage} ;
                Activity: {activity}</div>);
            ls.push({
                name: name + " (" + ref + ")",
                record: row,
                description: description,
                url: defautlUrl,
                lastUpdate: row.orgdatetime,
                lastStatus: status,
                lastActivity: activity,
                lastPriority: priority,
                lastStage: stage
            })
        }

        _this.arrayholder = ls;
        _this.setState({
            list: ls
        });

        /*await LoadDataNoCondition("databases","list",_this,params,(data)=>{
            data = SortDataDesc("orgdatetime",data);
            _this.arrayholder = data;
            _this.setState({
                list: data
            });
        });*/
    }
    getData = async () => {


    };

    onChangeTypeFilter =async (keyIn) => {
        let val = keyIn.target.value;
        console.log("onChangeTypeFilter > ", val)
        this.setState({
            typeFilter: val
        });

        await this.onClickBtnFilterSearch();
    }
    handleChange = async (e, key) => {
        const value = e.value;
        console.log("handleChange --> ", key, " > ", value);
        this.setState({
            [key]: value,
        })

        if (key === "selectedModule" && this.state.Org !== "") {
            await this.fetchDataByFilter()
        }

    }
    handleChangeInput = (key, val) => {
        let tmp = this.state;
        tmp.newEntry[key] = val;
        this.setState(tmp);
        console.log("handleChangeInput > ", key, " > ", val);
    }

    handleChangeInput2 = (key, e) => {
        let val = e.target.value;
        let tmp = this.state;
        tmp.newEntry[key] = val;
        this.setState(tmp);
        console.log("handleChangeInput2 > ", key, " > ", val);
    }

    openNewCaseDrawer = () => {
        this.setState({
            showNewCase: true,
        })
    }
    closeNewCaseDrawer = () => {
        this.setState({
            showNewCase: false,
        })
    }

    onClickBtnFilterSearch = async () => {
        await this.loadDatabase();
        let _this = this;
        let arrayholder = this.arrayholder;
        let ls=[];
        let viewRecord = null;
        console.log("onClickBtnFilterSearch 1 (:)--> ", arrayholder);
        for(let i in this.state.DatabasesView){
            let row=this.state.DatabasesView[i];
            if(row.org!==this.state.selectedCompany || row.module!==this.state.selectedProject){
                continue
            }
            if(row.name!==this.state.typeFilter){continue}
            viewRecord = row;
        }

        /**
         ** let now search our data
         **/

        if(viewRecord===null){
            return
        }
        const isInArray=(arr,checkVal)=>{
            let boo=false;
            for(let i in arr){
                let item=arr[i];
                if(item ===checkVal){
                    boo=true;
                }
            }
            return boo;
        }
        const isQualify=(targets,valueIn)=>{
            console.log("HHHHH---:> << ",valueIn," > ",targets," > ",(targets===null))
            if(JSON.stringify(targets)==="{}"){return true}
            let boo=false;
            let hasData=false;
            for(let i in targets){
                hasData=true;
                if(valueIn===i){
                    boo=true;
                }
            }

            if(!hasData){
                return true;
            }
            return boo;
        }

        for(let i  in arrayholder){
            let row=arrayholder[i];
            //let check condition on fields
            let rec = row.record.data;
            let boo=true;

            for(let a in viewRecord.fields){
                let fieldName = a;
                let fieldList =JSON.parse( viewRecord.fields[a]);
                const itemToCheck =rec[fieldName];

                if(!isInArray(fieldList,itemToCheck)){
                    boo=false;
                }

            }



            if(!boo){continue}

            if(!isQualify(viewRecord.statutes,row.lastStatus)){
                continue
            }
            if(!isQualify(viewRecord.stages,row.lastStage)){
                continue
            }
            if(!isQualify(viewRecord.priorities,row.lastPriority)){
                continue
            }
            if(!isQualify(viewRecord.activities,row.lastActivity)){
                continue
            }

            ls.push(row);

        }
        this.setState({
            list: ls,
            searchText: "",
        })
    }

    onSearch = async (textInput) => {
        await this.loadDatabase();
        console.log("onSearch > ", textInput)
        let ls = this.arrayholder;
        let newData = ls.filter(item => {
            const itemData = JSON.stringify(item).toLocaleLowerCase();
            const textData = textInput.toLocaleLowerCase();
            return itemData.indexOf(textData) > -1
        });
        this.setState({
            list: newData,
            searchText: textInput,
        })
    }
    onChangeSearch = (inputObject) => {
        /*const text = inputObject.target.value;
        let ls = [];
        ls = this.arrayholder;
        let newData = ls.filter(item => {
            const itemData = JSON.stringify(item).toLocaleLowerCase();
            const textData = text.toLocaleLowerCase();
            return itemData.indexOf(textData) > -1
        });
        this.setState({
            list: newData,
            searchText: text,
        })*/
    }
    closeDrawer = () => {
        this.setState({
            showNewCase: false,
        })
    }
    closeNewCaseDrawer = () => {
        this.setState({
            showNewCase: false,
        })
    }
    getDatabaseAttributes = () => {
        let _this = this;
        let userInfo = GetUserToken();
        let {project} = this.getInfo();
        let org = userInfo.Org;

        let ls = [];
        let defautlUrl = "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
        for (let i in this.state.Attributes) {
            let row = this.state.Attributes[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            let name = GetRecordDisplayName(org, project, row, this.state.Attributes, "displayselection")
            ls.push(row)
        }
        ls = SortData("position", ls);
        return ls

    }
    getHandleChangeValKey = (key) => {
        if (typeof this.state.newEntry[key] === "undefined") {
            return ""
        }
        return this.state.newEntry[key];
    }

    getAttributes = () => {
        let _this = this;
        let userInfo = GetUserToken();
        let {project} = this.getInfo();
        let org = userInfo.Org;

        let ls = [];
        for (let i in this.state.Attributes) {
            let row = this.state.Attributes[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            ls.push(row)
        }
        ls = SortData("position", ls);
        return ls

    }

    validateSubmitINput = () => {
        let attributes = this.getDatabaseAttributes();
        let newEntry = this.state.newEntry;
        for (let i in attributes) {
            const row = attributes[i];
            console.log("validateSubmitINput > ", newEntry[row.fieldname], row.fieldname, attributes);
            console.log("validateSubmitINput 2  > ", newEntry);
            if (row.mandatory) {
                if (typeof newEntry[row.fieldname] === "undefined") {
                    alert("Sorry " + row.fieldname + " is required field and can't be empty!");
                    return false;
                }
                if (newEntry[row.fieldname] === "") {
                    alert("Sorry " + row.fieldname + " is required field and can't be empty!");
                    return false;
                }
            }
        }
        return true;
    }

    onSubmitRecord = async () => {
        if (!this.validateSubmitINput()) {
            return
        }
        let _this = this;

        if (!window.confirm("Are you sure to submit this record!")) {
            return
        }
        let {project, org} = this.getInfo();


        let fieldsList = GetListField(org, project, this.state.Attributes, this.state.Databases);
        let fieldsListOriginal = this.getAttributes();
        console.log(":::::)-> Org: ", org, " > ", project, " > ", fieldsList);
        /*let ls = [];
        for (let i in this.state.Attributes) {
            const row = this.state.Attributes[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            fieldsListOriginal.push(row);
        }*/

        let o = {};
        for (let i in fieldsList) {
            const row = fieldsList[i];
            const key = row.field;
            let val = this.state.newEntry[key];
            const type = findRecordType(key, fieldsList);
            if (type === "float") {
                val = parseFloat(val)
            } else if (type === "number") {
                val = parseInt(val)
            } else if (type === "boolean") {
                val = val === "yes"
            } else {
                //todo do nothing
            }
            o[key] = val;
        }


        let inData = {data: o}
        let names = GetRecordDisplayName(org, project, inData, this.state.Attributes, "displaydelection");
        console.log("onSubmitRecord send 1 > ", o, " > ", this.state.newEntry);
        let uniqueKeyField = findRecordKeyField2(fieldsListOriginal, "unique");
        let uniqueValue = "";
        if (typeof o[uniqueKeyField] !== "undefined") {
            uniqueValue = o[uniqueKeyField];
        }
        let hub = {
            Org: org,
            module: project,
            Data: o,
            Ref: uniqueValue,
            names: names,
            Email: findRecordKey2(fieldsListOriginal, "email", o),
            Phone: findRecordKey2(fieldsListOriginal, "phone", o),
            Username: findRecordKey2(fieldsListOriginal, "username", o),
            Name: findRecordKey2(fieldsListOriginal, "name", _this),
            Surname: findRecordKey2(fieldsListOriginal, "surname", o),
            Password: findRecordKey2(fieldsListOriginal, "password", o),
            UniqueKey: uniqueKeyField
        }


        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = hub;
        post.Params = {}
        let endpoint = "/common/entity/databases/insert"; // "/manager/entity/insert/extensions";

        console.log("onSubmitRecord send 2 > ", post);

        await LoadDataAnyEndpoint(post, endpoint, "Data", this, async (data) => {
            console.log("onSubmitRecord response > ", data);
            await fetchDataEntity("Databases", "", "", _this, undefined, "common/entity/databases/list");
            await _this.loadDatabase();
            _this.closeDrawer();
            _this.setState({
                newEntry: {},
            });
            await SubmitLogInformation(org, project, "new case", "all", "all", uniqueValue, o, _this)
            alert("Thank you record added!")

        });


    }
    requestNewActionOpen = (row) => {
        let tmp = this.state;
        tmp.showActions = {};
        tmp.showActions[row.name] = true;
        tmp.ActionData = row;
        this.setState(tmp);
    }
    requestNewActionClose = (row) => {
        let tmp = this.state;
        tmp.showActions = {};
        this.setState(tmp)
    }
    requestNewActionHandleVisibleChange = (row, visible) => {
        let tmp = this.state;
        tmp.showActions[row.name] = visible;
        this.setState(tmp);
    };

    getVisibility = (row) => {
        let boo = false;
        if (typeof this.state.showActions[row.name] !== "undefined") {
            boo = this.state.showActions[row.name];
        }
        return boo;
    }
    getSelectedPopoverTitle = () => {
        let name = "none";
        for (let i in this.state.showActions) {
            name = i;
        }
        return name;
    }
    getInfo = () => {
        let userInfo = GetUserToken();
        let extension = "", project = "", name = userInfo.FullName, email = userInfo.Username, phone = userInfo.Phone,
            org = userInfo.Org;
        for (let i in this.state.UserProjects) {
            let row = this.state.UserProjects[i];
            if (row.user === userInfo.Username) {
                project = row.project;
            }
        }
        for (let i in this.state.UserVoips) {
            let row = this.state.UserVoips[i];
            if (row.user === userInfo.Username) {
                extension = row.extension;
            }
        }

        return {extension, project, name, email, phone, org}

    }
    renderProjectSelection = () => {

        let data = [];
        let company = this.state.selectedCompany;
        for (let i in this.state.Projects) {
            let row = this.state.Projects[i];
            console.log("&&&&--isMo> ", company, " > ", row.org)
            if (company === row.org) {
                data.push(row)
            }
        }
        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={data}
                label={"Select Project"}
                name={"selectedProject"}
                message={"Please select your project!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedProject}
                recordOptionKey={"name"}
                recordOptionValue={"name"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
        )
    }
    renderCompaniesSelection = () => {

        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={this.state.Companies}
                label={"Select Company"}
                name={"selectedCompany"}
                message={"Please select your company!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedCompany}
                recordOptionKey={"customernumber"}
                recordOptionValue={"customernumber"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
        )
    }

    handleChangeFilter = (val, key) => {
        console.log("handleChangeFilter--> ", val, key)
        let tmp = this.state;
        tmp.filters[key] = val;
        this.setState(tmp);
    }
    handleChangeFilterAddition = (val, key) => {
        console.log("handleChangeFilterAddition--> ", val, key)
        let tmp = this.state;
        tmp.filtersAdditions[key] = val;
        this.setState(tmp);
    }
    renderFilterOptions = () => {
        let options = this.getDatabaseAttributes();
        let ls = [];
        for (let i in options) {
            let row = options[i];
            if (row.datatype === "list") {
                let arr = [];// row.options.split(",");
                for (let a in row.options) {
                    arr.push(a);
                }
                ls.push(
                    <Col span={7}>
                        <Select
                            showSearch
                            style={{margin: 10, maxWidth: "100%", minWidth: "100%"}}
                            placeholder={"Select " + row.fieldname}
                            name={row.fieldname}
                            onChange={(e, ee) => this.handleChangeFilter(e, row.fieldname)}
                        >
                            {arr.map((record, index) => {
                                return (
                                    <Option value={record}>{record}</Option>
                                )
                            })}
                        </Select>
                    </Col>
                )
            }
        }

        return (
            <Card title="Filter by Options">
                <Row style={{
                    display: "flex",
                    maxWidth: "100%",
                    minWidth: "100%",
                    borderBottomWidth: 1,
                    borderColor: "black",
                }}>
                    {ls.map((row => {
                        return row
                    }))}
                    <Col span={7}>
                        <Button
                            type="dashed"
                            icon={<SearchOutlined/>}
                            onClick={this.onClickBtnFilterSearch}
                            style={{margin: 10, marginLeft: 20}}
                        >
                            Search
                        </Button>
                    </Col>
                </Row>
            </Card>
        )
    }
    renderFilter3 = () => {

        return (
            <div>

                <Search
                    placeholder="input search text"
                    allowClear
                    enterButton="Search"
                    size="large"
                    onSearch={this.onSearch}
                    style={styles.inputSearch}
                    onChange={this.onChangeSearch}
                />

            </div>
        )
    }
    renderFilter2 = () => {
        let userInfo = GetUserToken();
        let {project} = this.getInfo();
        let org = userInfo.Org;
        let state = this.state;
        let _this = this;
        const buildSelect = (arrayIn, name, label) => {
            let ls = [];
            for (let i in arrayIn) {
                const row = arrayIn[i];
                if (row.org !== org) {
                    continue
                }
                if (row.module !== project) {
                    continue
                }

                ls.push({
                    key: row.name,
                    val: <span style={{color: row.color}}>{row.name}</span>,
                })
            }
            return (
                <Col span={7}>
                    <Select
                        name={name}
                        placeholder={"Select " + name}
                        onChange={(e) => this.handleChangeFilterAddition(e, name)}
                        style={{minWidth: "100%", margin: 10}}
                    >
                        {ls.map((record) => {
                            return (
                                <Option value={record.key}>{record.val}</Option>
                            )
                        })}
                    </Select>
                </Col>
            )
        }

        return (
            <Card title="Filter by status stage and activity">
                <Row style={{
                    display: "flex",
                    maxWidth: "100%",
                    minWidth: "100%",
                    borderBottomWidth: 1,
                    borderColor: "black",
                }}>
                    {buildSelect(this.state.Statuses, "status", "Status")}
                    {buildSelect(this.state.Stages, "stages", "Stages")}
                    {buildSelect(this.state.Priorities, "priorities", "Priorities")}
                    {buildSelect(this.state.Activities, "activities", "Activities")}
                    <Col span={7}>
                        <Button
                            type="dashed"
                            icon={<SearchOutlined/>}
                            onClick={this.onClickBtnFilterAdditionalSearch}
                            style={{margin: 10, marginLeft: 20}}
                        >
                            Search
                        </Button>
                    </Col>
                </Row>
            </Card>
        )
    }
    renderButtonRequestAction = (item) => {
        let _this = this;
        /*
        showActionActivity:false,
            showActionStage:false,
            showActionActionStatus:false,
            */
        const makeButtons = () => {
            return (
                <div style={styles.makeButtons}>
                    {this.getSelectedPopoverTitle()}
                    <br/>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionActivity: true, showActions: {}})}
                    >
                        Activity
                    </Button>

                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionStage: true, showActions: {}})}
                    >
                        Stage
                    </Button>
                    <br/>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionStatus: true, showActions: {}})}
                    >
                        Status
                    </Button>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionPriority: true, showActions: {}})}
                    >
                        Priority
                    </Button>
                    <br/>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionComment: true, showActions: {}})}
                    >
                        Comment
                    </Button>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionReminder: true, showActions: {}})}
                    >
                        Reminder
                    </Button>
                    <br/>
                    <a onClick={_this.requestNewActionClose}>Close</a>
                </div>
            )
        }

        return (
            <Popover
                content={makeButtons()}
                title="New Action"
                trigger="click"
                visible={this.getVisibility(item)}
                onVisibleChange={(visible) => this.requestNewActionHandleVisibleChange(item, visible)}
            >
                <a onClick={() => this.requestNewActionOpen(item)}>
                    <PlusOutlined color={"blue"} size={56}/>
                </a>
            </Popover>
        )
    }
    renderRadioOptions=()=>{
        let ls=[];
        console.log("renderRadioOptions > ",this.state.DatabasesView);
        let databaseView  = SortDataDesc("position",this.state.DatabasesView);
        for(let  i in databaseView){
            let row=databaseView[i];
            if(row.org!==this.state.selectedCompany || row.module!==this.state.selectedProject){
                continue
            }
            ls.push(row)
        }
        return(
            <React.Fragment>
                <span style={{color:"red"}}>Choose type of report: </span>
            <Radio.Group
                onChange={this.onChangeTypeFilter}
                value={this.state.typeFilter}
                style={{margin: 10}}
            >

                {ls.map((row=>{
                    return(
                        <Radio value={row.name}>{row.name}</Radio>
                    )
                }))}
                {/*<Radio value={"options"}>Options</Radio>
                <Radio value={"status"}>Status & Stage</Radio>
                <Radio value={"any"}>Any key</Radio>*/}
            </Radio.Group>
            </React.Fragment>
        )
    }
    render() {
        const {initLoading, loading, list} = this.state;

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>

                    <div style={{minWidth: "100%", padding: 10}}>

                        <div style={styles.radiusMe}>

                            <PageHeader
                                info={this.getInfo()}
                                className="site-page-header"
                                onBack={() => window.history.back()}
                                title={"View incident"}
                                subTitle="Helpdesk management system"
                                extra={[]}
                            >
                            </PageHeader >
                            {/*<HeaderNewCase _this={this} info={this.getInfo()}/>*/}
                        </div>
                        <Row style={{margin:10}}>
                            <Col span={12}>
                                {this.renderCompaniesSelection()}
                            </Col>
                            <Col span={12}>
                                {this.renderProjectSelection()}
                            </Col>
                        </Row>

                        {this.renderRadioOptions()}


                        <List
                            className="demo-loadmore-list"
                            loading={initLoading}
                            itemLayout="horizontal"
                            dataSource={this.state.list}
                            renderItem={item => (
                                <List.Item
                                    actions={[<a key="list-loadmore-edit">edit</a>,
                                        <a onClick={() => this.requestMoreDetailView(item)}
                                           key="list-loadmore-more">more</a>]}
                                >
                                    <Skeleton avatar title={false} loading={item.loading} active>
                                        <List.Item.Meta
                                            avatar={
                                                <Avatar
                                                    src="https://www.startpage.com/av/proxy-image?piurl=https%3A%2F%2Fcdn2.iconfinder.com%2Fdata%2Ficons%2Finstagram-ui%2F48%2Fjee-74-512.png&sp=1607435819T1e8d4ca58b8e5351ae3f9867c2f7fd235e526d729156530a6ef04f4dfdd65fe0"/>
                                            }
                                            title={<a>{item.name}</a>}
                                            description={<div>
                                                {item.description}
                                                <span style={{fontSize: 11, color: "blue"}}>
                                                    Updated:{moment(item.lastUpdate, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YY HH:mm:ss")}</span>

                                            </div>}
                                        />
                                        <div>
                                            {this.renderButtonRequestAction(item)}
                                        </div>
                                    </Skeleton>
                                </List.Item>
                            )}
                        />
                    </div>
                </div>
                <DrawerNewEntry
                    _this={this}
                    attributes={this.getAttributes()}
                    closeDrawer={this.closeDrawer}
                    onSubmitRecord={this.onSubmitRecord}
                    visible={this.state.showNewCase}
                    handleChangeInput={this.handleChangeInput}
                    getHandleChangeValKey={this.getHandleChangeValKey}
                    title={"CREATE NEW CASE"}
                />
                <NewActivityDrawer _this={this}/>
                <NewStatusDrawer _this={this}/>
                <NewPriorityDrawer _this={this}/>
                <NewStageDrawer _this={this}/>
                <NewCommentDrawer _this={this}/>
                <NewReminderDrawer _this={this}/>
                <MoreDetailDrawer _this={this}/>
            </Page>
        );
    }
}

export default Connector(WorkboardViewIncidentPage);

const styles = {
    radiusMe: {
        border: "1px solid red",
        borderRadius: 5,
    },
    buttonNewCase: {
        minWidth: "18%",
        maxWidth: "18%",
        margin: 10,
    },
    inputSearch: {
        minWidth: "100%",
        maxWidth: "100%",
        margin: 10,
    },
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    },
    makeButtons: {
        /*display:"flex",
        flex:1,
        minWidth:150,
        maxWidth:150,
        justifyContent:"center"*/
    },
    buttonMaker: {
        marginTop: 10,
        minWidth: "50%",
        maxWidth: "50%",

    }
}

